import { render, staticRenderFns } from "./ignoreStudentDialog.vue?vue&type=template&id=76110ebe"
import script from "./ignoreStudentDialog.vue?vue&type=script&lang=js"
export * from "./ignoreStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./ignoreStudentDialog.vue?vue&type=style&index=0&id=76110ebe&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports